"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.error.profession_required': 'Please select a profession before proceeding',
    'onboarding.error.profession_select_first': 'Please select a profession first',
    'onboarding.error.avatar_name_required': 'Avatar name is required',
    'onboarding.error.avatar_name_provide': 'Please provide an avatar name',
    'onboarding.error.model_required': 'Please select an AI model before proceeding',
    'onboarding.error.answer_required': 'Answer is required',
    'onboarding.error.complete_required_step': 'Please complete the required step',
    'onboarding.error.complete_step': 'Please complete step',
    'onboarding.error.before_finishing': 'before finishing',
    'onboarding.error.professions_load_failed': 'Failed to load professions',
    'onboarding.error.professions_load_general': 'Error loading professions',
    'onboarding.error.steps_load_failed': 'Failed to load steps',
    'onboarding.error.steps_load_general': 'Error loading steps',
    'onboarding.error.questions_load_failed': 'Failed to load questions',
    'onboarding.error.questions_load_general': 'Error loading questions',
    'onboarding.error.load_failed': 'Failed to load onboarding data',
    'onboarding.error.load_general': 'Error loading onboarding',
    'onboarding.error.save_failed': 'Failed to save onboarding',
    'onboarding.error.save_general': 'Error saving onboarding',
};
